import CardNews from './CardNews';

export default CardNews;
